import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { resetStore } from "src/store/actions";
import { getFlashStoreData } from "../../../api/bi/index";

export const flashMyStoreData = createAsyncThunk(
  "/report/flashMySale",
  (docId: any) => getFlashStoreData(docId)
);
export const flashGOIStoreData = createAsyncThunk(
  "/report/flashGOISale",
  (docId: any) => getFlashStoreData(docId)
);

const initialState: any = {
  myStore: {
    data: [],
    status: "initial",
    error: null,
    docId: ""
  },
  goiStore: {
    data: [],
    status: "error",
    error: null,
    docId: ""
  }
};

const flashSalesSlice = createSlice({
  name: "flashSales",
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(resetStore, (state, action) => {
        return initialState;
      })
      .addCase(flashMyStoreData.pending, (state) => {
        state.myStore.status = "pending";
      })
      .addCase(flashMyStoreData.fulfilled, (state, { payload }) => {
        state.myStore.status = "idle";
        state.myStore.docId = payload.data.docId;
        state.myStore.data = payload.data;
      })
      .addCase(flashMyStoreData.rejected, (state, _action) => {
        state.myStore.status = "error";
        state.myStore.data = [];
      })
      .addCase(flashGOIStoreData.pending, (state) => {
        state.goiStore.status = "pending";
      })
      .addCase(flashGOIStoreData.fulfilled, (state, { payload }) => {
        state.goiStore.status = "idle";
        state.goiStore.docId = payload.data.docId;
        state.goiStore.data = payload.data;
      })
      .addCase(flashGOIStoreData.rejected, (state, _action) => {
        state.goiStore.status = "error";
        state.goiStore.data = [];
      });
  }
});

export default flashSalesSlice.reducer;
